import axiosInstance from "./AxiosInstance"

// Get all Pathyas
export function getPathyaList(  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = "") {
  return axiosInstance.post("pathyas/list",{
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  })
}

export const createPathya = (formData) => {
  return axiosInstance.post("pathyas/add", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updatePathya = (formData) => {
  return axiosInstance.post("pathyas/edit", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Delete Pathya
export function deletePathya(pathya_id) {
  return axiosInstance.post("/pathyas/delete", { pathya_id })
}

